import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material';
import { DashboardService } from 'src/app/services/dashboard.service';
import { LoginService } from 'src/app/services/login.service';
import { LoginComponent } from '../login.component';

@Component({
  selector: 'app-forgotpassword',
  templateUrl: './forgotpassword.component.html',
  styleUrls: ['./forgotpassword.component.scss']
})
export class ForgotpasswordComponent implements OnInit {
   @ViewChild('digit1Input',null) digit1Input: ElementRef;
  @ViewChild('digit2Input',null) digit2Input: ElementRef;
  @ViewChild('digit3Input',null) digit3Input: ElementRef;
  @ViewChild('digit4Input',null) digit4Input: ElementRef;
  @ViewChild('digit5Input',null) digit5Input: ElementRef;
  @ViewChild('digit6Input',null) digit6Input: ElementRef;
  emailScreen = 1;
  emailVlaue;
  userNotFoundError;
  enteredOTP: string = '';
  showSuccessMessage: boolean = false;
  resetMessage = '';
  digits: string[] = ['', '', '', '', '', '']; // Initialize an array with 6 empty strings
  otpForm: FormGroup;
  errorMsg = '';
  signupForm: FormGroup;
  hide = true;
  constructor( private dashboardService: DashboardService,private fb: FormBuilder,private loginService: LoginService,private dialogRef: MatDialogRef<LoginComponent>) {
   }

  ngOnInit() {
    
    this.otpForm = this.fb.group({
      digit1: ['', Validators.required],
      digit2: ['', Validators.required],
      digit3: ['', Validators.required],
      digit4: ['', Validators.required],
      digit5: ['', Validators.required],
      digit6: ['', Validators.required],
    });
    this.signupForm = this.fb.group({
      password: ['', [Validators.required]],
      confirmPassword: ['',[Validators.required]],
      email: ['']
    }, { validator: this.passwordMatchValidator });
  }
  forgotPasswordForm: FormGroup = new FormGroup({
    email: new FormControl('', [Validators.required, Validators.email]),
  });
  
  passwordMatchValidator(formGroup: FormGroup) {
    const password = formGroup.get('password').value;
    const confirmPassword = formGroup.get('confirmPassword').value;

    if (password !== confirmPassword) {
      formGroup.get('confirmPassword').setErrors({ passwordMismatch: true });
    } else {
      formGroup.get('confirmPassword').setErrors(null);
    }
  }
  otpScreen(action){
    if(action == 'request'){
      this.resetMessage = "OTP has been resend";
      this.otpForm.reset();
    }
    this.loginService.checkUser({email:this.emailVlaue}).subscribe((response: any) => {
      if (response.code == 1) {
            this.userNotFoundError = '';
            this.resetMessage = `OTP has been send to ${this.emailVlaue} successfully`;
        this.emailScreen = 2;
      } else {
        this.userNotFoundError = "Please enter a valid registered email address."
        setTimeout(() => {
          this.userNotFoundError = '';
        }, 3000);      
      }
    })
  }
  onDigitInput(digit: number): void {
    const nextDigit = digit + 1;

    // Check if the current digit is less than 6 before shifting focus
    if (digit < 6) {
      const nextInput = this[`digit${nextDigit}Input`];

      // Manually focus on the next input element
      if (nextInput) {
        nextInput.nativeElement.focus();
      }
    }
  }
vrifyOtp(){
  let OTP = '' +this.otpForm.value.digit1+this.otpForm.value.digit2+this.otpForm.value.digit3+this.otpForm.value.digit4+this.otpForm.value.digit5+this.otpForm.value.digit6;
  this.loginService.verifyOtp({email:this.emailVlaue,userotp:OTP}).subscribe((response: any) => {
    if(response.code == -1){
      this.errorMsg = "Invalid OTP";
    } else if(response.code == 1){
      this.resetMessage = '';
      this.emailScreen = 3;
    }
  });
}
resetPassword(){
  this.signupForm.value.email = this.emailVlaue;
  console.log("askdksad",this.emailVlaue)
  this.loginService.resetPassword(this.signupForm.value).subscribe((response: any) => {
    console.log(response);
    if(response.code == 1){
      this.emailScreen = 4;
      setTimeout(() => {
        window.location.reload();
      }, 500); 
    }
  })
}

}
